var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "custom-black-list-extra-options" },
      [
        _c(
          "VButton",
          {
            ref: "button",
            on: {
              mouseover: function ($event) {
                return _vm.loadNameBlackListSettings()
              },
              click: function ($event) {
                return _vm.toggleNameSettings()
              },
            },
          },
          [
            _vm._v("\n      精确匹配列表"),
            _c("VIcon", { attrs: { icon: "right-arrow", size: 16 } }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "custom-black-list-extra-options" },
      [
        _c(
          "VButton",
          {
            on: {
              mouseover: function ($event) {
                return _vm.loadRegexBlackListSettings()
              },
              click: function ($event) {
                return _vm.toggleRegexSettings()
              },
            },
          },
          [
            _vm._v("\n      正则匹配列表"),
            _c("VIcon", { attrs: { icon: "right-arrow", size: 16 } }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }